import { createContext } from 'react'

// The page header's actions node, which the Calendar section's view portals its New menu into
export const CalendarHeaderActionsContainerContext = createContext(null)
